import { Injectable } from "@angular/core";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessJsonUploadServiceSub } from "src/app/commons/kymw00/pless-json-upload-sub.service";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { KYMW6901ProposalTabModel } from "../kymw6901-proposal-tab.model";


/**
 * イメージ写真ファイルをアップロードするサービス
 *
 * @export ImagePhotoFileUploadService
 * @class ImagePhotoFileUploadService
 * @extends {PlessJsonUploadServiceSub}
 */
@Injectable()
export class ImagePhotoFileUploadService extends PlessJsonUploadServiceSub<null> {
  private model: KYMW6901ProposalTabModel;
  private successFunc = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub,
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof ImagePhotoFileUploadService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({});
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof ImagePhotoFileUploadService
   */
  execute(model: KYMW6901ProposalTabModel, file: File, successFunc?: () => void): void {
    this.model = model;
    this.successFunc = successFunc;
    this.sendFile('imagePhotoFileUpload', this.getBody(), file);
  }

  /**
   * API通信成功時の処理
   *
   * 
   * @memberof ImagePhotoFileUploadService
   */
  success(): void {
    if (this.successFunc) {
      this.successFunc();
    }
  }
}

